import React from 'react';
import './NotFound.css';
import { Link } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';

export default function NotFound({
  // message = 'Sorry, this page does not exist.',
  message = '抱歉，此页面不存在.',
  showGoBackButton = true,
}) {
  const context = useAppContext();

  return (
    <div className={'not-found'}>
      <div>
        <h4>{message}</h4>
        {showGoBackButton && context.appConfig.showStudyList && (
          <h5>
            <Link to={'/studylist'}>点击返回检查列表</Link>
          </h5>
        )}
      </div>
    </div>
  );
}
